import React from 'react'
import About from './About'
import Contact from './Contact'
import Products from './Products'

const Home = () => {
    return (
        <div className='hero'>
            <div class="card bg-dark text-white border-0">
                <img src="/Assest/bg.jpg" class="card-img" alt="Back Ground Image" height='850px' />
                <div class="card-img-overlay">
                    <div className="container">
                        <h5 class="card-title display-1 text-black fw-bolder mb-0 "> WINTER ARRIVALS </h5>
                        <p class="card-text lead fs-2  text-black"> Whoever said money can’t buy happiness clearly didn’t know where to shop!  </p>
                    </div>

                </div>
            </div>
            
            <Products/>
            <About/>
            <Contact/>
            </div>
    )
}

export default Home